import './../../assets/styles/screens/additionalDocs/AdditionalDocs.scss';
import { ReactComponent as SpinnerIcon } from '../../assets/icons/simple_spinner.svg';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { Context } from 'context/Context';
import { ActionType, AppContext } from 'context/interfaces';
import CpeClient from 'context/CPE';
import { DefaultDocsQuestionsState, DocsDataQuestions, DocsQuestionsState } from 'types/cpeDocs';
import ConfirmButton from 'components/common/ConfirmButton';
import { CpeDocData } from 'types/cpeDocs';
import DocsQuestions from 'components/docsQuestions/DocsQuestions';

const AdditionalDocs = (): JSX.Element => {
	const history = useHistory();
	const ctx = useContext(Context) as AppContext;
	const { id } = useParams<{ id: string }>();
	const [validateDocs, setValidateDocs] = useState<boolean>(false);
	const [docsQuestions, setDocsQuestions] = useState<DocsDataQuestions[]>([]);
	const [isDisabled, setIsDisabled] = useState<boolean>(true);

	const redirectToGallery = (): void => {
		history.push(`/${id}/photo/sections`);
	};

	const validateDocsQuestions = (): void => {
		const questionnaireIsValid = ctx.cpeDocumentValidation?.every(
			(item) => item.selectableValue === true || item.selectableValue === false
		);

		setIsDisabled(!questionnaireIsValid);
	};

	const saveQuestionSelection = (documentsStates: DocsQuestionsState[]): void => {
		CpeDocData.forEach((doc) => {
			const docIndex = documentsStates.findIndex((docState) => docState.documentType === doc.type);
			if (docIndex === -1) {
				documentsStates.push({
					documentType: doc.type,
					selectableValue: false,
				});
			}
		});
		ctx.dispatch({ type: ActionType.SET_CPE_DOCUMENT_VALIDATION, data: documentsStates });
		validateDocsQuestions();
	};

	useEffect(() => {
		(async (): Promise<void> => {
			try {
				const cpeClient = new CpeClient();

				if (ctx.cpeId) {
					const statusDocs = await cpeClient.getDocumentsStatus(ctx.cpeId);
					const documents: DocsDataQuestions[] = [];

					if (statusDocs?.documents?.pending) {
						statusDocs?.documents?.pending.forEach((item: any) => {
							documents.push({
								documentType: item.type,
								description: item.description,
							});
						});
					}

					setDocsQuestions(documents);

					if (documents.length === 0) {
						ctx.dispatch({ type: ActionType.SET_CPE_DOCUMENT_VALIDATION, data: DefaultDocsQuestionsState });
						redirectToGallery();
					} else {
						setValidateDocs(true);
					}
				} else {
					console.info('CPE :: No claim found');
					redirectToGallery();
				}
			} catch (error) {
				console.error('Error fetch claim:', error);
			}
		})();
	}, []);

	useEffect(() => {
		validateDocsQuestions();
	}, []);

	return (
		<div className="add-docs">
			{!validateDocs || docsQuestions.length === 0 ? (
				<div className="loading">
					<SpinnerIcon />
				</div>
			) : (
				<>
					<DocsQuestions documents={docsQuestions} onResult={saveQuestionSelection} />
					<div>
						<ConfirmButton text="Continuar" disabled={isDisabled} to={`/${id}/photo/sections`} />
					</div>
				</>
			)}
		</div>
	);
};

export default AdditionalDocs;
